import React, { createContext, useState, useContext } from 'react';

// --- CHANGE: Import JSON files ---
import viLang from "./locales/vi.json"
import enLang from './locales/en.json';

// Combine them into a single dictionary object
const translations = {
  vi: viLang,
  en: enLang
};
// ----------------------------------

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Initialize state with default language (e.g., 'vi')
  const [lang, setLang] = useState('en'); 

  // Function to switch the current language
  const switchLanguage = (language) => {
    setLang(language);
  };

  // Translation function: retrieves text based on the key
  const t = (key, replacements = {}) => {
  let text = translations[lang][key] || key;
  
  for (const prop in replacements) {
    text = text.replace(`{${prop}}`, replacements[prop]);
  }
  
  return text;
};

  return (
    <LanguageContext.Provider value={{ lang, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for consuming the context
export const useLanguage = () => useContext(LanguageContext);